import update from "immutability-helper";
import {
  all,
  curry,
  isEmpty,
  not,
  isNil,
  pluck,
  zipObj,
  pipe,
  toPairs,
  lift,
  equals,
  pickBy,
  dissoc,
  assoc,
  map,
  addIndex,
  any,
  identity,
} from "ramda";

export const toObj = curry((key, list) => zipObj(pluck(key, list), list));
export const up = curry((spec, data) => update(data, spec));
export const isNilOrEmpty = a => isNil(a) || isEmpty(a);

export const combineStrings = curry((separator, l, r) => {
  if (isNilOrEmpty(l) && isNilOrEmpty(r)) {
    return "";
  } else if (isNilOrEmpty(l)) {
    return r;
  } else if (isNilOrEmpty(r)) {
    return l;
  } else {
    return `${l}${separator}${r}`;
  }
});

export const isBlank = value =>
  value === undefined || isNil(value) || isEmpty(value);

export const notEmpty = value => not(isEmpty(value));

export const notBlank = value => not(isBlank(value));

export const toKeyValue = pipe(toPairs, lift(zipObj(["key", "value"])));

const diffPredicate = obj => (val, key) => !equals(obj[key], val);
export const diffObject = (obj1, obj2) => pickBy(diffPredicate(obj1), obj2);

export const renameProp = curry((oldName, newName, obj) =>
  dissoc(oldName, assoc(newName, obj[oldName], obj)),
);

export const mapIndexed = addIndex(map);

export const anyNotBlank = any(notBlank);

export const anyTrue = any(identity);
export const allTrue = all(identity);

export const mapWithIndex = addIndex(map);
